import { Avatar, Box, InputBase, Stack, Typography } from "@mui/material";
import { DamsColors } from "../styles/DamsColors";
import { DamsAppAsset } from "../../assets/registry";

interface SearchInputProps {
  label?: string;
  placeholder?: string;
  value?: string;
  handleChange?: (event: any) => void;
}
function SideBarSearchInput({
  label,
  placeholder,
  value,
  handleChange,
}: SearchInputProps): JSX.Element {
  return (
    <Stack>
      {label && (
        <Typography
          fontFamily={"Inter"}
          color={DamsColors.Authentication.InputLabel}
          fontSize={14}
          fontWeight={500}
          mb={1}
        >
          {label}
        </Typography>
      )}
      <Box sx={styles.inputOuterContainer} height={44}>
        <Avatar
          src={DamsAppAsset.icons.search}
          sx={styles.searchIcon}
          alt="search icon"
          variant="square"
        />

        <InputBase placeholder={placeholder} onChange={handleChange} value={value} fullWidth sx={styles.input} />
      </Box>
    </Stack>
  );
}

const styles = {
  inputOuterContainer: {
    display: "flex",
    alignItems: "center",
    padding: "0 8px",
    border: `1px solid ${DamsColors.Border.InputOuterBorder}`,
    borderRadius: "8px",
  },
  searchIcon: {
    marginRight: 1,
    color: DamsColors.SideBar.SideBarIcon,
    width: "20px",
    height: "20px",
  },
  input: {
    color: DamsColors.Text.SecondaryText,
    fontWeight: "400",
    fontSize: 15,
    fontFamily: "Inter",
  },
};

export { SideBarSearchInput };
